export const environment = {
    base_Url: 'http://daltex.drmonkey.co/data/',
     base_Url1: 'https://daltex.herokuapp.com'
  //base_Url1: 'http://localhost:8080'
    // base_Url: 'https://fprestacionalwstst.azurewebsites.net/'
};
